import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext'; // Import AuthProvider
import ErrorBoundary from './components/ErrorBoundary';

// Log app configuration on startup
console.log('🚀 Bela Chat App Starting...');
console.log('📡 Configuration (loaded at server start):');
console.log(`   PORT: ${process.env.PORT || 'default (3000)'}`);
console.log(`   APP_MODE: ${process.env.REACT_APP_APP_MODE || 'not set'}`);
console.log(`   API_URL: ${process.env.REACT_APP_API_URL || 'not set'}`);
console.log('💡 Note: If .env values seem wrong, restart the dev server to reload environment variables');
console.log('✅ App initialized successfully');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider> {/* Wrap App with AuthProvider */}
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
